
const MILESTONES = [
  { year: '2007', title: 'Foundation',        desc: 'Sylman Training Consultancy established with a vision to transform lives through quality education.' },
  { year: '2012', title: 'Expansion',          desc: 'Expanded to include corporate training and workplace skills development programmes.' },
  { year: '2018', title: 'Sylman Academy',      desc: 'Rebranded to Sylman Academy, reflecting our evolution into a comprehensive training institution.' },
  { year: '2020', title: 'Digital Innovation',  desc: 'Launched hybrid and online learning solutions, making training accessible nationwide.' },
  { year: '2024', title: 'QCTO Accreditation', desc: 'Achieved full QCTO accreditation — cementing our commitment to nationally recognised quality.' },
];

export default function OurStorySection() {
  return (
    <section className="section-wrap bg-white">
      <div className="section-inner">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Story */}
          <div>
            <p className="section-label">Our Story</p>
            <h2 className="section-heading">Rooted in Purpose,<br />Driven by Impact</h2>
            <div className="space-y-5 text-[#6b7280] leading-relaxed text-base">
              <p>
                What began in 2007 as Sylman Training Consultancy has evolved into one of South Africa's most trusted training institutions. Founded with a simple yet powerful vision — to transform potential into performance — we have consistently delivered excellence in education and skills development.
              </p>
              <p>
                Our journey from a small consultancy to a fully QCTO-accredited academy reflects our unwavering commitment to quality, innovation, and the belief that every individual deserves access to world-class training opportunities.
              </p>
              <p>
                Today, as Sylman Academy, we continue to build on our heritage while embracing the methodologies that enhance real-world learning outcomes for both individuals and organisations.
              </p>
            </div>
          </div>

          {/* Timeline */}
          <div className="relative">
            <div className="absolute left-4 top-0 bottom-0 w-px bg-[#c8e6cf]" />
            <div className="space-y-8">
              {MILESTONES.map((m, i) => (
                <div key={i} className="relative flex items-start gap-6">
                  <div className="w-8 h-8 bg-[#2D7F3E] rounded-full flex items-center justify-center relative z-10 flex-shrink-0">
                    <div className="w-2.5 h-2.5 bg-white rounded-full" />
                  </div>
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <span className="font-serif font-bold text-xl text-[#2D7F3E]">{m.year}</span>
                      <span className="font-semibold text-[#111111] text-sm">{m.title}</span>
                    </div>
                    <p className="text-[#6b7280] text-sm leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
